// extracted by mini-css-extract-plugin
export default {"container":"tR-z","title":"uR-z","link":"vR-z"};